import { render, staticRenderFns } from "./ExtratoTotalFormaPagamento.vue?vue&type=template&id=1ed8ae7d&scoped=true"
import script from "./ExtratoTotalFormaPagamento.vue?vue&type=script&lang=js"
export * from "./ExtratoTotalFormaPagamento.vue?vue&type=script&lang=js"
import style0 from "./ExtratoTotalFormaPagamento.vue?vue&type=style&index=0&id=1ed8ae7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8ae7d",
  null
  
)

export default component.exports